// Single source of truth for current build-slot availability.
// Update slotsFilled here when a slot opens or fills — Pricing's capacity
// band and HandoffDemo's "next slot" line both derive from this.
export const CAPACITY = {
  slotsTotal: 1,
  slotsFilled: 1,
};

export const capacityStatus = CAPACITY.slotsFilled >= CAPACITY.slotsTotal ? "filled" : "open";
export const capacityLabel = capacityStatus === "filled" ? "Filled" : "Open";
export const nextSlotLabel = capacityStatus === "filled" ? "Reserved" : "One slot open";
export const capacityCtaLabel = capacityStatus === "filled" ? "Join the waitlist" : "Claim next slot";
